module.exports = __webpack_public_path__ + "img/searchSvg.ca3fb9e3.svg";